<template>
    <modal @close="$emit('close')" class="lg:hidden xl:hidden">
    <div class="flex modal-mask mt-3">
        <div class="modal-wrapper relative" @click.self="$emit('close')">
            <div class="ml-auto flex arrow absolute"></div>
              <font-awesome-icon :icon="['fal', 'times']" class="absolute text-brand-grey-light pin-t pin-r mr-8 mt-4 cursor-pointer text-2xl z-50" @click="$emit('close')"></font-awesome-icon>
            <div class="modal-container flex flex-col">
                <div class="modal-body px-8 py-1">
                    <div class="flex items-center justify-start mt-8">
                        <p class="flex font-bold mr-1 text-sm whitespace-no-wrap">Ваш город: </p>
                        <p class="text-center font-bold text-sm">{{city}}?</p>
                    </div>
                </div>
                <div class="flex flex-col justify-center px-8 mt-4 pb-8">
                    <button class="pink-button outline-none w-full hover-up text-white font-bold my-2 mr-2 py-3 text-sm hover:bg-brand-yellow hover:text-main-text" @click.self="set_city(); $emit('close')">
                        Да
                    </button>
                    <button class="select-button outline-none w-full hover-up text-grey-darkest font-bold py-3 text-sm hover:bg-brand-yellow hover:border-brand-yellow" @click.self="$emit('open_list'); $emit('close')">
                        Нет, выбрать
                    </button>
                </div>
            </div>
        </div>
    </div>
    </modal>
</template>

<script>

import base from '@/clients/base';
import { mapActions } from 'vuex';
import Modal from '@/views/modals/base-modal';

export default {
  name: 'SelectCityMobile',
  components: { Modal },
  created() {
    base.get('/locations/guess')
      .then(({
        data: {
          currency, city, social_network_link, id, phone_code, is_playing_quizmaker, is_able_to_order_offline_games,
        },
      }) => {
        this.city = city;
        this.link = social_network_link;
        this.city_id = id;
        this.country_code = phone_code;
        this.currency = currency;
        this.is_playing_quizmaker = is_playing_quizmaker;
        this.is_able_to_order_offline_games = is_able_to_order_offline_games;
      });
    const escapeHandler = (e) => {
      if (e.key === 'Escape' && this.show) {
        this.$emit('close');
      }
    };
    document.addEventListener('keydown', escapeHandler);
    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', escapeHandler);
    });
  },
  data() {
    return {
      ext: '',
      show: true,
      city: '',
      link: '',
      country_code: '',
      is_playing_quizmaker: '',
      is_able_to_order_offline_games: '',
    };
  },

  methods: {
    ...mapActions(['selectCityInfo']),
    set_city() {
      this.selectCityInfo({
        city: this.city, social_network_link: this.link, first_init: true, id: this.city_id, phone_code: this.country_code, currency: this.currency, is_playing_quizmaker: this.is_playing_quizmaker, is_able_to_order_offline_games: this.is_able_to_order_offline_games,
      });
    },
  },
  watch: {
    city() {
      if (!this.city) this.$emit('close');
    },
    link(n, old) {
      if (n !== old) {
        this.$emit('city_link');
      }
    },
  },

};

</script>

<style scoped>
  .modal-mask {
  font-family: 'Montserrat', sans-serif;
}
    .modal-mask {
        z-index: 9998;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        vertical-align: middle;
        max-width: 400px;
        width: 400px;
    }

    .modal-container {
        box-shadow: 0 2px 4px rgba(168, 168, 168, 0.06);
        border-radius: 8px;
        background-color: #ffffff;
    }

    .modal-header h3 {
        width: 173px;
        height: 15px;
        color: #444444;
        font-family: "Montserrat Medium";
        font-size: 12px;
        font-weight: 500;
    }

    .pink-button {
        border-radius: 45px;
        background-color: #bd006c;
    }

    .select-button {
        border-radius: 45px;
        border: 1px solid #979797;
    }

    .modal-body {
        margin: 0 0;
    }


    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

</style>
